import { render, staticRenderFns } from "./DocumentTemplateCreate.vue?vue&type=template&id=e85d21ca"
import script from "./DocumentTemplateCreate.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports